export function isObjectEqual(a, b, exclusions = []) {
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);

  if (exclusions.length === 0) {
    if (aProps.length !== bProps.length) {
      return false;
    }
  }

  for (let i = 0; i < aProps.length; i++) {
    var propName = aProps[i];
    if (exclusions.indexOf(propName) !== -1) {
      // console.log('Exlusion found, skipping');
      continue;
    }

    if (a[propName] === undefined || b[propName] === undefined) {
      // console.log(`The key "${propName}" is not in both objects!`);
      return false;
    }
    if (a[propName] !== b[propName]) {
      console.log(
        // `The key "${propName}" is different.`,
        a[propName],
        b[propName]
      );
      return false;
    }
  }

  // console.log('The Objects are equivalent    ');
  return true;
}
